import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { useTranslation } from "react-i18next";
import { useStyles } from "./SliderDots.style";

interface ISliderDotsProps {
  listLength: number;
  activeDot?: number;
  isHideGamepad?: boolean;
  onDotClick?: (index: number) => void;
}

export const SliderDots: FC<
  ISliderDotsProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { listLength, activeDot, isHideGamepad, onDotClick, ...otherProps } =
    props;

  return (
    <div
      role="tablist"
      {...otherProps}
      className={clsx(classes.root, otherProps.className)}
    >
      {Array.from({ length: listLength }, (_, index) => (
        <div
          key={index}
          className={clsx(classes.dot, activeDot === index && "active")}
          role="tab"
          tabIndex={-1}
          aria-selected={activeDot === index}
          aria-label={t("A11y_Slide", { number: index + 1 })}
          onClick={() => onDotClick?.(index)}
        />
      ))}
    </div>
  );
};
